import DetailSection from './DetailSection';

export default DetailSection;
